var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.757,
    height: 45
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55493"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68826",
    d: "M13.018 36.39a2.187 2.187 0 0 1 .432-1.143C11.032 32.099 3.875 24.389.977 14.571c0 0-6.068 9.067 12.041 21.819Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68827",
    d: "M15.736 33.771C5.73 11.671 9.268 3.845 9.268 3.845c-2.105.175-7.281 3.628-6.946 8.373.565 8.144 9.036 19.141 11.713 22.43a5.754 5.754 0 0 1 1.701-.877Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68828",
    d: "M19.368 33.205c.215 0 .429 0 .643.015.5-7.25 1.424-25.216.93-30.189-.527-5.267-8.557-2.7-9.784.35-3.468 8.618 3.408 25.6 5.389 30.146a12.17 12.17 0 0 1 2.822-.322Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68829",
    d: "M20.856 33.295a10.838 10.838 0 0 1 1.757.345c4.13-8.275 7.518-19.124 6.873-26.4-.565-6.375-7.067-6.142-7.067-6.142.922 9.301-.979 27.126-1.563 32.197Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68830",
    d: "M31.051 6.251c1.033 10.438-5.4 23.776-7.465 27.737a4.69 4.69 0 0 1 1.394.9c4.057-5.761 9.46-12.154 10.886-19.83 1.168-6.357-4.815-8.807-4.815-8.807Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68831",
    d: "M37.1 14.571c-.582 7.578-8.457 17.268-11.651 20.913a2.121 2.121 0 0 1 .22.556C45.174 24.203 37.1 14.571 37.1 14.571Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68832",
    d: "M19.374 34.123c-3.01 0-5.451 1.084-5.451 2.432a6.119 6.119 0 0 0 .42 2.389 4.942 4.942 0 0 0 .321.709 1.8 1.8 0 0 1 .285-.373 3.447 3.447 0 0 1 1.1-.694 8.79 8.79 0 0 1 3.326-.587 9.624 9.624 0 0 1 2.615.339 4.228 4.228 0 0 1 1.813.942 1.847 1.847 0 0 1 .29.378 5.086 5.086 0 0 0 .319-.71 6.132 6.132 0 0 0 .421-2.389c-.007-1.347-2.446-2.436-5.459-2.436Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68833",
    d: "M19.413 38.739c-2.31 0-4.183.555-4.183 1.239s1.873 1.239 4.183 1.239 4.183-.555 4.183-1.239-1.876-1.239-4.183-1.239Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68834",
    d: "M20.54 42.896a26.635 26.635 0 0 0-3.408-.957c-.36-.039-.947.047-.947.75s.589 2.384 3.82 2.308c1.379-.031 2.158-.349 2.341-.774s-.132-.628-1.806-1.327Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68835",
    d: "m18.794 42.09 3.058 1s.739.22.93-.259.217-1.007-.576-1.058-5.298-.302-3.412.317Z"
  }))));
};
export default SvgLogo;